import { Check } from '@mui/icons-material';
import { ListItemText, MenuItem, Select, Typography, Button, Box } from '@mui/material';
import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import { setCookie } from '../../hooks/useCookie';

const CSTVDropDown = ({ numbers, func, setOpenSubscriptionSelectionModal }) => {
  const theme = useTheme();
  const [selectedNumber, setSelectedNumber] = useState('Select address');
  const [isOpen, setIsOpen] = useState(false);

  const handleSelectChange = event => {
    const number = event?.target?.value;
    if (number !== 'Select address') {
      setCookie('CO', 'SUBSCRIPTION_ID', number);
      const selectedAddress = numbers.find(item => item.value === number)?.addressInfo;
      setSelectedNumber(selectedAddress);
    } else setSelectedNumber(number);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <Box sx={styles(theme).dropdownCTAContainer}>
      <Select
        value={selectedNumber}
        onChange={handleSelectChange}
        onOpen={handleOpen}
        onClose={handleClose}
        open={isOpen}
        renderValue={selected => selected}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '10px',
              marginTop: '4px',
              boxShadow: `0px 2px 4px -1px ${theme.palette.primary.boxShadow}, 0px 4px 5px ${theme.palette.primary.boxShadow}, 0px 1px 10px ${theme.palette.primary.boxShadow}`,
            },
          },
        }}
        sx={styles(theme).csTVContainer}
      >
        {numbers.map(number => (
          <MenuItem
            key={number.value}
            value={number.value}
            onClick={number.onClick}
            disabled={!number.changeOffer}
            sx={styles(theme).menuItems}
          >
            <ListItemText primary={number.addressInfo} />
            {isOpen && selectedNumber === number.value && (
              <Check sx={{ color: `${theme.palette.secondary.greenCta}` }} />
            )}
          </MenuItem>
        ))}
        <MenuItem value='Select address'>
          <Typography sx={styles(theme).defaultMenuItem}>Select address</Typography>
        </MenuItem>
      </Select>
      <Button
        variant='buttonMedium'
        sx={styles(theme).dropdownCTA}
        disabled={selectedNumber === 'Select address'}
        onClick={() => {
          func();
          setOpenSubscriptionSelectionModal(false);
        }}
      >
        Confirm
      </Button>
    </Box>
  );
};

export default CSTVDropDown;
